import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';
import { Link } from 'react-router-dom';
import { space } from '../../styled';

export const Wrapper = styled(Link)`
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background: ${(props) => props.theme.color.light.default};

  &:hover {
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.125);
    background: ${(props) => props.theme.color.light.default};
  }

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: ${(props) => props.theme.color.dark.default};
  border-radius: 10px;
  position: relative;
  padding: 10px 25px;
  font-weight: 400;

  height: auto;
  width: 100%;
  overflow: hidden;
  text-align: left;

  ${space};

  ${mediaQuery('tablet')} {
    padding: 12px 16px;
  }
`;

const mobileLabel = css`
  ${mediaQuery('tablet', 'max')} {
    &:before {
      content: attr(data-title) ':';
      display: inline-block;
      margin-right: 12px;
      font-weight: 600;
      width: 70px;
    }
  }
`;

export const BreederContainer = styled.div`
  ${mobileLabel};
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  /* width: 50%; */
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 400;
`;

export const BreederTextContainer = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const BreederTitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BreederImage = styled.img`
  border-radius: 100%;
  width: 48px;
  height: 48px;
  object-fit: cover;
  margin-right: 15px;

  ${mediaQuery('tablet', 'min')} {
    display: none;
  }

  ${mediaQuery('desktop', 'min')} {
    display: block;
  }
`;

export const PreferencesContainer = styled(BreederContainer)`
  ${mediaQuery('tablet')} {
    margin-top: 12px;
  }
`;

export const PreferencesTextContainer = styled(BreederTextContainer)``;

export const BreedTitle = styled.div`
  max-width: 80%;
  word-break: normal;
`;

export const StatusContainer = styled.div`
  ${mobileLabel};

  ${mediaQuery('tablet')} {
    margin-top: 12px;
  }
`;

export const CreatedText = styled.div`
  /* width: 20%; */
  text-align: right;

  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const ActionsButton = styled(Button)`
  margin: 0 auto;
  padding: 0px 10px;
  max-width: 40px;

  ${mediaQuery('tablet')} {
    margin-top: 30px;
    max-width: none;
    width: 150px;

    svg {
      transform: rotate(90deg);
    }
  }
`;

export const ActionsIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  font-size: 20px;
  font-weight: 500;

  &:hover {
    opacity: 0.7;
  }

  /* ${mediaQuery('tablet', 'min')} {
    margin-left: 20px;
  }

  ${mediaQuery('tablet')} {
    margin-left: 10px;
  }

  ${mediaQuery('small')} {
    margin-bottom: 22px;
  } */
`;

export const PopperContainer = styled.div`
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: white;
  padding: 20px;
  text-align: center;

  #arrow {
    position: absolute;
    width: 10px;
    height: 10px;
    &:after {
      content: ' ';
      background-color: white;
      box-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: -25px; // padding + popper height
      left: 0;
      transform: rotate(45deg);
      width: 10px;
      height: 10px;
    }
  }

  &[data-popper-placement^='top'] > #arrow {
    bottom: -30px;
    :after {
      box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    }
  }
`;
